import { render, staticRenderFns } from "./pasteImg.vue?vue&type=template&id=15e20feb&scoped=true&"
import script from "./pasteImg.vue?vue&type=script&lang=js&"
export * from "./pasteImg.vue?vue&type=script&lang=js&"
import style0 from "./pasteImg.vue?vue&type=style&index=0&id=15e20feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e20feb",
  null
  
)

export default component.exports